  (() => {
    if (window.__bfmDatePanier) return;
    window.__bfmDatePanier = true;

    const TZ = 'America/Toronto';
    const ymd = (d) => new Intl.DateTimeFormat('en-CA',
      {timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'}).format(d);
    const minutesIci = (d) => {
      const p = new Intl.DateTimeFormat('en-CA',
        {timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false}).formatToParts(d);
      const g = (t) => Number(p.find((x) => x.type === t).value);
      return (g('hour') % 24) * 60 + g('minute');
    };
    const moisDe = (iso) => new Intl.DateTimeFormat('fr-CA',
      {timeZone: TZ, month: 'long', year: 'numeric'}).format(new Date(iso + 'T12:00:00'));
    const enLettres = (iso) => new Intl.DateTimeFormat('fr-CA',
      {timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long'}).format(new Date(iso + 'T12:00:00'));
    const enLettresLongues = (iso) => new Intl.DateTimeFormat('fr-CA',
      {timeZone: TZ, weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'})
      .format(new Date(iso + 'T12:00:00'));

    // La valeur qui fait foi. Le tiroir est re-rendu par l'API de rendu de
    // section : l'élément disparaît et revient, donc le DOM ne peut pas servir
    // de mémoire de ce que le client a choisi.
    let choisie = '';
    let enVol = null;

    const fermesDe = (root) => (root.dataset.fermes || '').split(',')
      .map((x) => x.trim()).filter(Boolean).map(Number);

    // Premier jour livrable : aujourd'hui si la tombée n'est pas passée,
    // sinon demain, en sautant les jours fermés.
    const minimum = (root) => {
      const tombee = Number(root.dataset.tombee || 13);
      const fermes = fermesDe(root);
      const ouvrable = (d) => !fermes.includes(new Date(ymd(d) + 'T12:00:00').getDay());
      const d = new Date();
      if (minutesIci(d) >= tombee * 60 || !ouvrable(d)) d.setDate(d.getDate() + 1);
      for (let i = 0; i < 14 && !ouvrable(d); i++) d.setDate(d.getDate() + 1);
      return ymd(d);
    };

    const tousLesRoots = () => [].slice.call(document.querySelectorAll('[data-bfm-dp]'));

    // La date est écrite DEUX fois, et les deux sont nécessaires.
    //
    //  - en ATTRIBUT de panier : c'est ce qui se rend à la commande, une seule
    //    fois pour toute la commande. Ruth le lit dans l'admin.
    //  - en PROPRIÉTÉ de chaque ligne : c'est la seule des deux que Shopify
    //    AFFICHE au client pendant le paiement. Un attribut de panier n'y
    //    paraît jamais — vérifié sur le vrai checkout le 30 sept. 2026.
    //
    // Sans la propriété, le client ne voit nulle part la date qu'il vient de
    // choisir et croit l'avoir perdue.
    // Le client lit « jeudi 1 octobre 2026 », pas « 2026-10-01 ». L'attribut de
    // commande garde la forme ISO, qui se trie ; la ligne porte la forme lisible,
    // qui est celle que le client voit au paiement et que Ruth lit sur la commande.
    const poserSurLignes = (cle, val) => {
      const tour = (reste) => {
        if (reste <= 0) return Promise.resolve();
        return fetch('/cart.js', {headers: {Accept: 'application/json'}})
          .then((r) => r.json())
          .then((c) => {
            const i = c.items.findIndex((it) => ((it.properties || {})[cle] || '') !== val);
            if (i === -1) return;
            // /cart/change.js REMPLACE tout le jeu de proprietes : envoyer la
            // seule cle qu'on gere effacerait les autres. Le 6 octobre 2026, le
            // message de carte d'un vrai client a ete detruit comme ca des qu'il
            // a choisi sa date. On fusionne, toujours.
            const avant = c.items[i].properties || {};
            const fusion = {};
            Object.keys(avant).forEach((k) => { fusion[k] = avant[k]; });
            fusion[cle] = val;
            return fetch('/cart/change.js', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({line: i + 1, properties: fusion})
            }).then((r) => {
              if (!r.ok) throw new Error('ligne');
              return tour(reste - 1);
            });
          });
      };
      return tour(30);   // garde-fou : jamais plus d'un tour par ligne plausible
    };

    // En cas d'échec on le DIT : une date perdue en silence, c'est une
    // livraison ratée.
    const enregistrer = (root, val) => {
      const cle = root.dataset.cle || 'Date de livraison';
      const err = root.querySelector('[data-err]');
      if (enVol) enVol.abort();
      enVol = new AbortController();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        signal: enVol.signal,
        body: JSON.stringify({attributes: {[cle]: val}})
      }).then((r) => {
        if (!r.ok) throw new Error('update');
        return poserSurLignes(cle, enLettresLongues(val));
      }).then(() => {
        if (err) { err.hidden = true; err.textContent = ''; }
      }).catch((e) => {
        if (e.name === 'AbortError') return;
        if (err) { err.hidden = false; err.textContent = "La date n'a pas pu être enregistrée. Réessayez."; }
      });
    };

    const dessine = (root) => {
      const grille = root.querySelector('[data-grille]');
      const etiq = root.querySelector('[data-mois]');
      const note = root.querySelector('[data-note]');
      if (!grille || !etiq || !root.dataset.min) return;

      const min = root.dataset.min;
      const max = root.dataset.max;
      const fermes = fermesDe(root);
      const curseur = root.dataset.curseur;           // 'AAAA-MM'
      const [an, mo] = curseur.split('-').map(Number);
      const premier = new Date(an, mo - 1, 1);
      const nbJours = new Date(an, mo, 0).getDate();
      const decalage = premier.getDay();              // dimanche = 0

      etiq.textContent = moisDe(curseur + '-01');
      grille.textContent = '';

      for (let i = 0; i < decalage; i++) {
        const v = document.createElement('span');
        v.className = 'bfm-cal__j bfm-cal__j--vide';
        grille.appendChild(v);
      }
      for (let j = 1; j <= nbJours; j++) {
        const iso = curseur + '-' + String(j).padStart(2, '0');
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bfm-cal__j';
        b.textContent = String(j);
        b.dataset.iso = iso;
        const ferme = fermes.includes(new Date(iso + 'T12:00:00').getDay());
        const hors = iso < min || iso > max;
        if (ferme || hors) {
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
        } else {
          b.setAttribute('aria-selected', iso === choisie ? 'true' : 'false');
          b.setAttribute('aria-label', enLettres(iso));
        }
        b.tabIndex = (iso === choisie || (!choisie && iso === min)) ? 0 : -1;
        grille.appendChild(b);
      }

      root.querySelector('[data-prec]').disabled = (curseur + '-01') <= min.slice(0, 7) + '-01';
      root.querySelector('[data-suiv]').disabled = (curseur + '-01') >= max.slice(0, 7) + '-01';

      if (note && choisie) note.textContent = 'Livraison le ' + enLettres(choisie) + '.';
    };

    const bouge = (root, iso) => {
      if (root.dataset.curseur !== iso.slice(0, 7)) {
        root.dataset.curseur = iso.slice(0, 7);
        dessine(root);
      }
      const b = root.querySelector('[data-iso="' + iso + '"]:not([disabled])');
      if (b) { b.tabIndex = 0; b.focus(); }
    };

    // Marque la journée choisie SANS reconstruire la grille quand on reste dans
    // le même mois. C'est essentiel : retirer du DOM le bouton qu'on vient de
    // cliquer détache la cible de l'événement, et le tiroir du panier prend
    // alors ce clic pour un clic « à l'extérieur » — il se referme au moment
    // même où le client choisit sa date.
    const marque = (r, iso) => {
      r.querySelectorAll('button[data-iso]').forEach((b) => {
        const cest = b.dataset.iso === iso;
        if (!b.disabled) b.setAttribute('aria-selected', cest ? 'true' : 'false');
        b.tabIndex = cest ? 0 : -1;
      });
      const note = r.querySelector('[data-note]');
      if (note) note.textContent = 'Livraison le ' + enLettres(iso) + '.';
    };

    const choisir = (root, iso) => {
      choisie = iso;
      tousLesRoots().forEach((r) => {
        r.classList.remove('bfm-cal--manque');
        if (r.dataset.curseur === iso.slice(0, 7)) {
          marque(r, iso);
        } else {
          r.dataset.curseur = iso.slice(0, 7);
          dessine(r);
        }
      });
      enregistrer(root, iso);
    };

    const init = (root) => {
      // Le theme re-rend le tiroir du panier apres un ajout : il remplace les
      // enfants du calendrier sans remplacer le noeud. data-pret survivait donc a
      // une grille redevenue vide, init sortait aussitot, et plus aucun jour
      // n'etait dessine jusqu'au rechargement de la page.
      const g0 = root.querySelector('[data-grille]');
      if (root.dataset.pret && g0 && g0.children.length) return;
      root.dataset.pret = '1';

      const min = minimum(root);
      const dmax = new Date(min + 'T12:00:00');
      dmax.setDate(dmax.getDate() + 365);
      root.dataset.min = min;
      root.dataset.max = ymd(dmax);

      // Au premier rendu le panier fait foi ; ensuite c'est le choix en mémoire.
      if (!choisie && root.dataset.valeur) choisie = root.dataset.valeur;
      if (choisie && (choisie < min || choisie > root.dataset.max)) choisie = '';
      root.dataset.curseur = (choisie || min).slice(0, 7);
      dessine(root);

      // Un article ajouté après le choix de la date n'en porte pas la propriété :
      // on la repose, sinon le paiement affiche la date sur certaines lignes
      // seulement.
      if (choisie) poserSurLignes(root.dataset.cle || 'Date de livraison', enLettresLongues(choisie));

      // Les ecouteurs vivent sur les ENFANTS. Si le noeud de grille porte deja sa
      // marque, c'est qu'il a survecu au re-rendu : ses ecouteurs aussi, et on
      // s'arrete ici pour ne pas les doubler.
      const gr = root.querySelector('[data-grille]');
      const pr = root.querySelector('[data-prec]');
      const sv = root.querySelector('[data-suiv]');
      if (!gr || !pr || !sv) return;
      if (gr.dataset.lie) return;
      gr.dataset.lie = '1';

      root.querySelector('[data-prec]').addEventListener('click', () => {
        const [a, m] = root.dataset.curseur.split('-').map(Number);
        const d = new Date(a, m - 2, 1);
        root.dataset.curseur = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
        dessine(root);
      });
      root.querySelector('[data-suiv]').addEventListener('click', () => {
        const [a, m] = root.dataset.curseur.split('-').map(Number);
        const d = new Date(a, m, 1);
        root.dataset.curseur = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
        dessine(root);
      });

      const grille = root.querySelector('[data-grille]');
      grille.addEventListener('click', (ev) => {
        const b = ev.target.closest('button[data-iso]');
        if (!b || b.disabled) return;
        ev.stopPropagation();
        choisir(root, b.dataset.iso);
      });

      // Les flèches parcourent le mois, comme dans un vrai calendrier.
      grille.addEventListener('keydown', (ev) => {
        const b = ev.target.closest('button[data-iso]');
        if (!b) return;
        const pas = {ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7}[ev.key];
        if (!pas) return;
        ev.preventDefault();
        const d = new Date(b.dataset.iso + 'T12:00:00');
        d.setDate(d.getDate() + pas);
        const iso = [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'),
                     String(d.getDate()).padStart(2, '0')].join('-');
        if (iso < root.dataset.min || iso > root.dataset.max) return;
        bouge(root, iso);
      });
    };

    const scan = () => tousLesRoots().forEach(init);

    // Le bouton de paiement est bloqué tant que la date est vide. On intercepte
    // au lieu de désactiver : un bouton grisé sans explication ressemble à un bris.
    const garde = (ev) => {
      const cible = ev.target;
      if (!cible || !cible.closest) return;
      if (!cible.closest('[name="checkout"], .cart__checkout-button')) return;
      const roots = tousLesRoots();
      if (!roots.length || choisie) return;
      ev.preventDefault();
      ev.stopPropagation();
      // Le calendrier visible — le tiroir et la page panier peuvent coexister,
      // et le client ne voit que l'un des deux.
      const root = roots.filter((r) => r.offsetParent !== null)[0] || roots[0];
      root.classList.add('bfm-cal--manque');
      const note = root.querySelector('[data-note]');
      if (note) note.textContent = 'Choisissez une date avant de passer au paiement.';
      root.scrollIntoView({block: 'center', behavior: 'smooth'});
      const b = root.querySelector('button[data-iso]:not([disabled])');
      if (b) b.focus();
    };
    document.addEventListener('click', garde, true);
    document.addEventListener('submit', garde, true);

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);

    // Le tiroir se réécrit sans émettre d'événement Shopify : on réobserve, en
    // différé pour ne pas rescanner à chaque mutation.
    let minuteur = null;
    new MutationObserver(() => {
      clearTimeout(minuteur);
      minuteur = setTimeout(scan, 80);
    }).observe(document.documentElement, {childList: true, subtree: true});
  })();
